var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"alert-cont",attrs:{"show":"","options":_vm.options,"variant":"danger"}},[_c('error-icon',{staticClass:"icon-default error"}),_vm._v(" "),_c('span',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.message)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6085c870","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/FormAlert.vue
// module id = null
// module chunks = 